import img1 from "./images/illustration/icon-sport-2.png";
import img2 from "./images/illustration/icon-sport-4.png";
import img3 from "./images/illustration/icon-sport-5.png";

const Benefits = () => {
  return (
    <>
      <section className="container-fluid mt-4 mb-4" id="continue">
        <section className="container d-flex  flex-column ">
          <section className="row mt-5">
            <div className="col-12">
              <h1 className="heading fw-bold mb-4">BENEFITS OF OUR <br /> FITNESS STUDIO</h1>
              <p className="mt-4">
                Nulla in eget tortor morbi enim maecenas aenean viverra. Sodales
                suscipit nunc elit arcu,<br /> pulvinar. Vestibulum enim eget
                vulputate tempus lacu.
              </p>
              <button type="button" class="btn btn-warning">Learn More</button>
            </div>
          </section>
          

          <div className="row  justify-content-center mt-4 vishal">
            
            <div className="col-12 col-md-6 col-xl-4 mt-4">
              <img src={img1} alt="image not found" className="w-25 raj " />
              <h5>The Best Coahes</h5>
            </div>
            <div className="col-12 col-md-6 col-xl-4 mt-4">
              <img src={img2} alt="image not found" className="w-25 raj" />
              <h5>Guaranteed Results</h5>
            </div>
            <div className="col-12 col-md-6 col-xl-4 mt-4">
              <img src={img3} alt="image not found" className="w-25 raj" />
              <h5>Our Best classNamees</h5>
            </div>
          </div>
        </section>
      </section>
    </>
  );
};

export default Benefits;
